import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetricsVisualizationEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 848,
	height: 514,
	viewBox: "0 0 848 514",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: 10.5,
			x2: 847.5,
			y2: 10.5,
			stroke: "#F1F3F5",
			strokeLinecap: "round",
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: 111.4,
			x2: 847.5,
			y2: 111.4,
			stroke: "#F1F3F5",
			strokeLinecap: "round",
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: 209.8,
			x2: 847.5,
			y2: 209.8,
			stroke: "#F1F3F5",
			strokeLinecap: "round",
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: 308.2,
			x2: 847.5,
			y2: 308.2,
			stroke: "#F1F3F5",
			strokeLinecap: "round",
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: 406.6,
			x2: 847.5,
			y2: 406.6,
			stroke: "#F1F3F5",
			strokeLinecap: "round",
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: 505,
			x2: 847.5,
			y2: 505,
			stroke: "#F1F3F5",
			strokeLinecap: "round",
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1088_4508",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 31,
			width: 848,
			height: 456,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 848,
				height: 456,
				transform: "translate(0 31)",
				fill: "url(#paint0_linear_1088_4508)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1088_4508)",
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .05,
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 297.026V487H848V95.7086C847.411 95.7084 846.812 95.6207 846.22 95.4367L812.829 85.0612L779.763 100.996C779.131 101.3 778.452 101.492 777.755 101.561L744.819 104.854L711.611 145.512C710.492 146.883 708.825 147.689 707.055 147.716L672.987 148.236L639.047 165.517C638.625 165.731 638.179 165.896 637.718 166.006L602.385 174.444C601.465 174.664 600.505 174.663 599.584 174.44L563.977 165.848C563.75 165.794 563.526 165.726 563.307 165.645L532.059 154.108L500.053 201.88C498.465 204.25 495.428 205.174 492.789 204.09L460.309 190.747L428.029 215.96C427.412 216.442 426.706 216.799 425.951 217.01L390.641 226.876C390.575 226.894 390.508 226.912 390.441 226.928C390.375 226.944 390.31 226.959 390.244 226.972L354.893 234.295L354.849 234.304L319.828 241.283L284.867 252.491C284.545 252.594 284.215 252.67 283.88 252.718L248.493 257.753C248.257 257.787 248.019 257.806 247.78 257.812L212.324 258.595C211.147 258.621 209.989 258.3 208.993 257.672L176.188 236.998L144.268 254.989L109.261 276.749C108.723 277.084 108.136 277.331 107.52 277.481L72.4013 286.081L37.322 297.403C36.6905 297.607 36.0297 297.704 35.3662 297.692L0 297.026Z",
				fill: "#495057"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1088_4508",
			x1: 424,
			y1: 0,
			x2: 424,
			y2: 456,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopOpacity: 0
			})]
		}) })
	]
});
export default SvgMetricsVisualizationEmptyState;
